import { render, staticRenderFns } from "./AllowanceSave.vue?vue&type=template&id=632994db&"
import script from "./AllowanceSave.vue?vue&type=script&lang=js&"
export * from "./AllowanceSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports